import get from 'lodash/get'
import api from '../utils/Api';
import {
  UPLOAD_FILE,UPLOAD_FILE_CSV,
  UPLOAD_FILE_NSA_CSV,UPLOAD_FILE_INTERNATINAL,UPLOAD_FILE_CORPORATE,UPLOAD_FILE_MINISTRY
} from "../../constants/ApplicationUrl";

export const uploadFileService = {
  uploadFile(params) {
    return api.POSTDATA(UPLOAD_FILE, params).then((response) => {
      const { data, status } = get(response, 'data') || {};
      if (status) {
        return (data);
      } else {
        return Promise.reject();
      }
    }).catch(e => {
      return Promise.reject(e);
    });
  },
  uploadFileBtn(params) {
    return api.POSTDATA(UPLOAD_FILE_CSV, params).then((response) => {
      const { data, status } = get(response, 'data') || {};
      if (status) {
        return (data);
      } else {
        return Promise.reject();
      }
    }).catch(e => {
      return Promise.reject(e);
    });
  },
  uploadFileNsaBtn(params) {
    return api.POSTDATA(UPLOAD_FILE_NSA_CSV, params).then((response) => {
      const { data } = response;
      return data;
    }).catch(e => {
      return Promise.reject(e);
    });
  },
  uploadFileInternatinalBtn(params) {
    return api.POSTDATA(UPLOAD_FILE_INTERNATINAL, params).then((response) => {
      const { data } = response;
      return data;
    }).catch(e => {
      return Promise.reject(e);
    } );
  },
  uploadFileCorporateBtn(params){
    return api.POSTDATA(UPLOAD_FILE_CORPORATE, params).then((response) => {
      const {data} = response;
      return data;
    }).catch(e => {
      return Promise.reject(e);
    } );
  },
  uploadFileMinistryBtn(params) {
    return api.POSTDATA(UPLOAD_FILE_MINISTRY, params).then((response) => {
      const { data } = response;
      return data;
    }).catch(e => {
      return Promise.reject(e);
    });

  }
}
